import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import FooterLinkBlock from './footer-link-block/footer-link-block';
import Logo from '../../components/logo/Logo';

import 'bootstrap/dist/css/bootstrap.css';
import './footer.styl';

import { FooterCategories as FooterCategoriesEN, Copyright as CopyrightEN, FooterSocialText as FooterSocialTextEN } from '../../input-text/en/footer';
import { FooterCategories as FooterCategoriesNL, Copyright as CopyrightNL, FooterSocialText as FooterSocialTextNL } from '../../input-text/nl/footer';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isHidden: false };

    this.setLocale = this.setLocale.bind(this);
  }

  componentWillMount() {
    if (this.props.location.pathname === '/login' || this.props.location.pathname === '/login/' ||
      this.props.location.pathname === '/signup' || this.props.location.pathname === '/signup/' ||
      this.props.location.pathname === '/login/recover' || this.props.location.pathname === '/login/recover/' ||
      this.props.location.pathname === '/resetpass' || this.props.location.pathname === '/resetpass/') {
      this.setState({ isHidden: true });
    }
    else {
      this.setState({ isHidden: false });
    }
  }

  componentWillReceiveProps(nextProp) {
    if (nextProp.location.pathname === '/login' || nextProp.location.pathname === '/login/' ||
      nextProp.location.pathname === '/signup' || nextProp.location.pathname === '/signup/' ||
      nextProp.location.pathname === '/login/recover' || nextProp.location.pathname === '/login/recover/' ||
      nextProp.location.pathname === '/resetpass' || nextProp.location.pathname === '/resetpass/') {
      this.setState({ isHidden: true });
    }
    else {
      this.setState({ isHidden: false });
    }
  }

  setLocale(locale) {
    this.FooterCategories = null;
    this.Copyright = null;
    this.FooterSocialText = null;
    switch (this.props.locale) {
      case 'en':
        this.FooterCategories = FooterCategoriesEN;
        this.Copyright = CopyrightEN;
        this.FooterSocialText = FooterSocialTextEN;
        break;
      case 'nl':
        this.FooterCategories = FooterCategoriesNL;
        this.Copyright = CopyrightNL;
        this.FooterSocialText = FooterSocialTextNL;
        break;
      default:
        this.FooterCategories = FooterCategoriesEN;
        this.Copyright = CopyrightEN;
        this.FooterSocialText = FooterSocialTextEN;
    }
  }

  render() {
    this.setLocale(this.props.locale);

    return (
      <footer className={'page-footer ' + (this.state.isHidden ? 'hidden' : '')}>
        <div className="container">
          <div className="row">
            <div className="page-footer__mobile-titles">
              {this.FooterCategories
                .filter(category => category.nameAddress)
                .map(category => {
                  return (
                    <Link
                      key={category.key}
                      to={category.nameAddress}
                    >
                      {category.name}
                    </Link>
                  );
                })
              }
            </div>
            <div className="hidden-xs">
              {this.FooterCategories.map(category => {
                return (
                  <div key={category.key} className={'col-sm-2 ' + (category.nameAddress ? '' : 'hidden-xs')}>
                    <FooterLinkBlock
                      name={category.name}
                      nameAddress={category.nameAddress}
                      links={category.links} />
                  </div>
                );
              })
              }
              <div className="col-sm-2 page-footer__logo-column">
                <Logo ver="unfolded" neg={true} size="medium" />
              </div>
            </div>
          </div>
          <div className="page-footer__copyright">
            <Link to={this.Copyright.contact.address} className="visible-xs-inline">{this.Copyright.contact.text}</Link>
            <span />
            <div className="page-footer__copyright__right">
              <span>&copy; <a href="http://www.nazka.be/index_en.html" target="_blank">Nazka Mapps</a> | <a href={this.Copyright.termsOfUse.linkAddress} target="_blank">{this.Copyright.termsOfUse.text}</a></span>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default withRouter(connect(mapStateToProps, null)(Footer));



// WEBPACK FOOTER //
// ./src/containers/footer/Footer.js